<template>
  <!-- <a-locale-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-locale-provider> -->
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
// import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'
import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'

export default {
  data () {
    return {
      locale: enUS
    }
  },
  mounted () {
    const { $store } = this
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop')
          $store.dispatch('setSidebar', true)
          break
        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet')
          $store.dispatch('setSidebar', false)
          break
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile')
          $store.dispatch('setSidebar', true)
          break
      }
    })
  }
}
</script>
<style>
#app {
  height: 100%;
}
a[disabled] .anticon{
  color: #00000040 !important
}
.btn-box{
  margin-left: 0;
  border-top: 1px #e8e8e8 solid;
  margin-top: 20px;
  padding-top: 20px;
  margin-bottom:-24px;
}
.btn-left{
  padding-left: 12.5%;
}
.cancel-body-padding .ant-card-body{
  padding:0 !important;
}
/* .increase-edit-padding{
  padding: 10px 0 !important;
} */
.ant-btn.ant-btn-dashed{
  background: #f6f6f6;
  color:#999;
}
.ant-btn.ant-btn-dashed:hover{
  color: #40a9ff;
}
.ant-table-tbody p{
  margin-bottom:0;
}
.ant-list-bordered .ant-list-item{
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.must-fill label:before {
  display: inline-block;
  margin-right: 4px;
  content: '*';
  font-family: SimSun;
  line-height: 1;
  font-size: 14px;
  color: #f5222d;
}
.check-box{
  color: #f5222d;
  font-size: 15px;
}
</style>
